import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox, Input } from 'legacy/libs/react-form-tools'

import { GetText } from 'lib/gettext'

export default createReactClass({
  displayName: 'Description',

  mixins: [SchemaBranchMixin],

  schema: {
    description: '',
  },

  render() {
    return (
      <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 md:gap-8">
        <div>
          <ValidationBox
            fieldPath="description"
            className="validationbox"
            errorMessageClassName="text-danger mt-1 text-xs"
          >
            <label
              htmlFor="id_create-description"
              className="mb-2 block text-default-light"
            >
              <GetText>Description</GetText>
            </label>

            <Input type="textarea" className="input _textarea" />
          </ValidationBox>
        </div>

        <p className="text-xs text-default-light sm:pt-6">
          <GetText>Provide a brief description of your entry.</GetText>
        </p>
      </div>
    )
  },
})
